import useUser from "@app/zustand/user";
import { RoomType, Profession } from "@prisma/client";
import { useMemo } from "react";
import { useSearchParams } from "react-router";

const FeedFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const me = useUser((state) => state.user);

  const mySpeRoomId = useMemo(() => {
    return me?.rooms.find((r) => r.room.roomType === RoomType.SPECIALITE)?.room.id;
  }, [me?.rooms]);

  const myEtablissementRoomId = useMemo(() => {
    return me?.rooms.find((r) => r.room.roomType === RoomType.ETABLISSEMENT)?.room.id;
  }, [me?.rooms]);

  const onlyMySpe =
    searchParams.get("qRoomType") === RoomType.SPECIALITE && searchParams.get("qRoomId") === mySpeRoomId
      ? "true"
      : "false";

  if (me?.profession === Profession.INFIRMIER) return null;

  return (
    <>
      <div className="flex w-full flex-col items-start justify-between px-2 sm:flex-row">
        <div className="flex items-center">
          <input
            type="checkbox"
            name="only_my_spe"
            id="only_my_spe"
            value={onlyMySpe}
            checked={onlyMySpe === "true"}
            onChange={(e) => {
              e.preventDefault();
              if (onlyMySpe === "true") {
                searchParams.set("qRoomId", myEtablissementRoomId!);
                searchParams.set("qRoomType", RoomType.ETABLISSEMENT);
              } else {
                searchParams.set("qRoomId", mySpeRoomId!);
                searchParams.set("qRoomType", RoomType.SPECIALITE);
              }
              setSearchParams(searchParams);
            }}
            className="peer hidden"
          />
          <label
            htmlFor="only_my_spe"
            className="w-max cursor-pointer py-1 text-sm text-sky-900 border border-sky-900/10 shadow-sm rounded-md px-2 flex flex-row items-center gap-3 bg-white"
          >
            {onlyMySpe === "true" ? (
              <>
                <span>🏥</span> <span>Voir toutes les spés</span>
              </>
            ) : (
              <>
                <span>🧰</span> <span>Voir seulement ma spé</span>
              </>
            )}
          </label>
        </div>
      </div>
    </>
  );
};

export default FeedFilter;
